/**
 * Onboarding states where the case sits with staff and the CLIENT has
 * nothing to do but wait. The portal shows the same reassuring "in review"
 * treatment (a "what happens next" timeline + a "message your advisor" CTA)
 * for all of them, so none reads as a dead-end silent wait.
 *
 * `pending_decision` (a clean hand-off to a supervisor) and
 * `pending_rejection` (an agent proposed rejection, awaiting a manager's
 * sign-off) are INTERNAL segregation-of-duties sub-states. From the
 * client's side they are simply "in final review" — we deliberately never
 * reveal the proposal, the reviewer, or that a rejection is on the table.
 * That mirrors the privacy rule applied to the staff timeline.
 *
 * Shared by the onboarding wizard (`Onboarding.tsx`) and the dashboard
 * `OnboardingProgressCard` so the two surfaces can never drift on which
 * states count as "in review".
 */
export const IN_REVIEW_SLUGS: ReadonlySet<string> = new Set([
  'under_review',
  'pending_decision',
  'pending_rejection',
]);

export function isInReview(slug: string | null | undefined): boolean {
  return slug != null && IN_REVIEW_SLUGS.has(slug);
}
